import React from "react";
// import DashboardPage from "../../../app/modules/Dashboard/DashboardPage";
import DashboardPage2 from "../../../app/modules/Dashboard/DashboardPage2";

export function Dashboard() {
  return (
    <>
      {/* <DashboardPage /> */}
      <DashboardPage2 />
    </>
  );
}
